import type { FC } from "react";
import { Icon } from "../Icon/Icon";
import type { IconNames } from "../Icon/svg";
import classes from "./Doughnut.module.scss";
import { v4 as uiidv4 } from "uuid";
import { useMatchMedia } from "../../hooks/useMatchMedia";

export interface InfoType {
	text: string;
	color: string;
}

export interface DoughnutProps {
	title: string;
	name: IconNames;
}

export interface DoughnutComponent extends FC<DoughnutProps> {}

export const Doughnut: DoughnutComponent = ({ title, name }) => {
	const { isMobile }: any = useMatchMedia();

	const info: InfoType[] = [
		{ text: "Private Sale", color: "#F261FF" },
		{ text: "Ecosystem", color: "#FF1A7A" },
		{ text: "Team", color: "#020CFF" },
		{ text: "Advisors", color: "#16FFE3" },
		{ text: "Binance Launchpad", color: "#9FFB00" },
		{ text: "Move & Earn", color: "#10DD24" },
	];

	return (
		<div className={classes.wrapper}>
			<div className={classes.content}>
				<h4 className={classes.title}>{title}</h4>
				<div className={classes.doughnut}>
					<Icon
						className={classes.icon}
						name={name}
						size={!isMobile ? 200 : 100}
					/>
					<div className={classes.infos}>
						{info.map(({ text, color }) => (
							<div key={uiidv4()} className={classes.info}>
								<span className={classes.color} style={{ background: color }} />
								<span className={classes.text}>{text}</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
